// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0cb3b92a","455":"501c6eae"}[chunkId] + ".chunk.js";
};